<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
          <ion-buttons slot="start">
          <ion-menu-button></ion-menu-button>
          </ion-buttons>
        <ion-title>
          INFORMACIÓN
        </ion-title>
      </ion-toolbar>
    </ion-header>
    
    <ion-content :fullscreen="true">
      <div class="mt-3 row justify-content-center">
        <div class="col-10">
          <ion-button  @click="muestraModalInformacion(1);" expand="block" color="tertiary">
            <fa :icon="['fad', 'user-secret']" class="mr-2 fa-fw"></fa>
            POLÍTICA DE PRIVACIDAD
            </ion-button>
          <ion-button @click="muestraModalInformacion(2);" class="mt-2" expand="block" color="tertiary">
            <fa :icon="['fas', 'clipboard-list-check']" class="mr-2 fa-fw"></fa>
            TÉRMINOS Y CONDICIONES
          </ion-button>
        </div>
      </div>
      <br><br>
      <br><br>
      <div class="row text-muted mt-5">
        <div class="col text-center">
          <p class="font-italic mb-1" style="font-size:14px;">Desarrollado por Inverluz S.A.</p>
          <p class="font-italic" style="font-size:13px;" v-text="'Copyright © '+anoActual"></p>
        </div>
      </div>
    </ion-content>
    
  </ion-page>
</template>

<script>
import { modalController, IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButton , IonButtons, IonMenuButton} from '@ionic/vue';
import { defineComponent } from 'vue';
//import axios from 'axios';
import modalInformacion from '../components/ModalInformacion.vue';

export default defineComponent({
  name: 'App',
  components: {
    IonHeader, IonToolbar, IonTitle, IonContent, IonButton, IonPage, IonMenuButton, IonButtons
  },
  data(){
    return {
      anoActual :'',
      modalVerInformacion:null
    }
  },
  mounted(){
    this.anoActual = new Date().getFullYear();
  },
  methods:{
    async muestraModalInformacion(tipoInfo){
      this.modalVerInformacion = await modalController
        .create({
          component: modalInformacion,
          backdropDismiss : false,
          componentProps  : {
            tipoInfo       : tipoInfo
          },
        });
      this.modalVerInformacion.present();
    },
  }
});
</script>